export default "__VITE_ASSET__Bz03Cfqk__"